const fetchProjectsFromAPI = async () => {
  try {
    const response = await fetch('https://leoleveque.net/api/projects');
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const data = await response.json();

    const projects = data.map(project => ({
      title: project.title,
      description: project.description,
      detailsLink: project.details_link,
      images: project.images 
    }));

    return projects;
  } catch (error) {
    console.error("Error fetching projects:", error);
    return [];
  }
};

export default fetchProjectsFromAPI;
